import { render, staticRenderFns } from "./ResultMenu.vue?vue&type=template&id=6ab6a748&"
import script from "./ResultMenu.vue?vue&type=script&lang=js&"
export * from "./ResultMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports